import { PublicKey } from "@solana/web3.js";
export const PROGRAM_ID = new PublicKey("nftvJPn25R8AM52AeQM7TxkN7CpgWvYVVEh5qgHPaQx");
//# sourceMappingURL=constants.js.map